import React from "react";
import PropTypes from "prop-types";

const Instructors = ({ users }) =>
  users.map(user => <div key={user.id}>{user.full_name_reverse}</div>);

Instructors.propTypes = {
  users: PropTypes.array.isRequired
};

export default Instructors;
